import type { TranslationInterface } from '.';

export const RomanianLanguage: TranslationInterface = {
  write_a_message_placeholder: 'Scrie un mesaj...',
  your_issue_has_been_resolved: 'Problema ta a fost rezolvată!',
  new_conversation: 'Conversație nouă',
  welcome_screen_title: 'Bine ai venit la chat-ul nostru de suport',
  welcome_screen_description:
    'Suntem aici să te ajutăm! Începe o conversație și îți vom răspunde cât mai curând posibil.',
  your_name_placeholder: 'Numele tău',
  your_email_placeholder: 'Adresa ta de email',
  start_chat_button: 'Vorbește cu suportul',
  start_chat_button_loading: 'Se conectează...',
  i_need_more_help: 'Am nevoie de mai mult ajutor',
  this_was_helpful: 'Acest lucru a fost util',
  optional: 'Opțional',
  no_conversations_yet: 'Încă nu există conversații',
  back_to_conversations: 'Înapoi la conversații',
  closed_conversations: 'Conversații închise',
  csat_title: 'Cum a fost conversația ta?',
  csat_submitted_title: 'Ai evaluat conversația ca',
  csat_feedback_placeholder: 'Spune-ne mai multe... (opțional)',
  follow_up_placeholder: 'Continuă…',
  companion_layout_label: 'Aspect',
  companion_layout_floating: 'Flotant',
  companion_layout_sidebar: 'Bară laterală',
  companion_layout_fullscreen: 'Ecran complet',
  companion_close: 'Închide',
  companion_history: 'Istoricul conversațiilor',
  companion_expand_chat: 'Extinde chatul',
  companion_sidebar_dock_label: 'Andocare',
  companion_sidebar_side_label: 'Parte',
  companion_sidebar_left: 'Stânga',
  companion_sidebar_right: 'Dreapta',
  companion_resize_chat: 'Redimensionează chatul',
  scroll_to_bottom: 'Derulează în partea de jos',
  thinking: 'Mă gândesc…',
  running: 'În curs…',
  steps: 'pași',
  step_arguments: 'Argumente',
  step_result: 'Rezultat',
  attach_files:
    'Atașează imagini, videoclipuri, PDF-uri sau foi de calcul (dimensiune maximă 25 MB)',
  mark_page_active:
    'Dă clic pe ceva din pagină pentru a-l marca — Esc pentru anulare',
  mark_page: 'Marchează ceva din pagină pentru a întreba despre acel element',
  stop_response: 'Oprește răspunsul',
  copy_reply: 'Copiază răspunsul',
  mentions_empty: 'Niciun rezultat',
  copied: 'Copiat',
  send_message: 'Trimite mesajul',
  upload_failed: 'Încărcarea a eșuat: {error}',
  remove_attachment: 'Elimină atașamentul',
  json_no_items: 'Niciun element',
  json_no_data: 'Nu există date',
  json_no_chart_data: 'Nu există date pentru grafic',
  json_unsupported: 'Neacceptat: {type}',
  json_see_less: 'Vezi mai puțin',
  json_phone_agent: 'Agent telefonic',
  json_phone_agent_test: 'Testează pe web',
  page_context_remove: 'Elimină contextul paginii',
  json_see_more: 'Vezi încă {count}',
  queued_label: '{count} În așteptare',
  remove_queued_message: 'Elimină mesajul din coadă',
  send_queued_now: 'Trimite acum mesajele din coadă',
  turn_failed_message: 'Ceva nu a mers bine și răspunsul nu a sosit.',
  turn_failed_retry: 'Încearcă din nou',
  page_mark_hint: 'Dă clic pe ceva pentru a-l marca',
  page_mark_escape: 'Esc',
  page_mark_shape_box: 'Chenar',
  page_mark_shape_circle: 'Cerc',
  page_mark_shape_arrow: 'Săgeată',
  page_mark_shape_bracket: 'Paranteză',
  page_mark_shape_underline: 'Subliniere',
  page_mark_shape_highlight: 'Evidențiere',
  page_mark_shape_strike_through: 'Tăiere',
  page_mark_shape_crossed_off: 'Tăiere în cruce',
  page_mark_shape_aria: 'Forma marcajului: {shape}',
  page_mark_note_placeholder: 'Adaugă o notă… (Enter pentru atașare)',
  page_mark_attach: 'Atașează marcajul',
  page_mark_remove: 'Elimină {label}',
  page_mark_region: 'Zonă marcată',
  page_mark_default_message: 'Ce este acesta?',
  file_rejected:
    'Tipul de fișier nu este acceptat sau fișierul este prea mare.',
  dictate: 'Dictează',
  stop_dictation: 'Oprește dictarea',
  dictation_mic_blocked: 'Permite accesul la microfon pentru a dicta',
  dictation_unavailable: 'Dictarea nu este disponibilă momentan',
  questions_back: 'Înapoi',
  questions_next: 'Înainte',
  questions_send: 'Trimite',
  questions_type_answer: 'Scriu eu',
  questions_answer_placeholder: 'Scrieți răspunsul dvs.…',
  close_conversation_title: 'Închide conversația',
  close_conversation_description: 'Sigur vrei să închizi această conversație?',
  close_conversation_cancel: 'Nu',
  close_conversation_confirm: 'Da',
  dialog_close: 'Închide',
  zoom_in: 'Mărește',
  zoom_out: 'Micșorează',
  reset_zoom: 'Resetează zoomul',
  support_chat_aria_label: 'Chat de asistență',
};
